
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 250 250"}},[_c('path',{staticClass:"stroke",attrs:{"d":"M82.9 140.4c-3.9-8-6.1-17.2-6.1-26.9 0-30.7 21.8-55.7 48.7-55.7s48.7 24.9 48.7 55.7c0 9.8-2.2 18.9-6.1 26.9"}}),_c('path',{staticClass:"stroke",attrs:{"d":"M82.9 140.4c-7.1 5.4-11.3 12.2-11.3 19.6 0 17.7 24.2 32 54 32s54-14.3 54-32-24.2-32-54-32c-17.4 0-32.8 4.9-42.7 12.4m11.4-70.2L54.8 57.8s-1.7 40.7 31.1 22.5m70.5-10.1L196 57.8s1.7 40.7-31.1 22.5"}}),_c('ellipse',{staticClass:"fill",attrs:{"cx":"108.2","cy":"160","rx":"8.4","ry":"7.3"}}),_c('ellipse',{staticClass:"fill",attrs:{"cx":"142.8","cy":"160","rx":"8.4","ry":"7.3"}}),_c('circle',{staticClass:"fill",attrs:{"cx":"114","cy":"101.3","r":"4.7"}}),_c('circle',{staticClass:"fill",attrs:{"cx":"138.1","cy":"101.3","r":"4.7"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      